import { render } from "./UpcomingBatches.vue?vue&type=template&id=0d72cd88&scoped=true"
import script from "./UpcomingBatches.vue?vue&type=script&lang=js"
export * from "./UpcomingBatches.vue?vue&type=script&lang=js"

import "./UpcomingBatches.vue?vue&type=style&index=0&id=0d72cd88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d72cd88"]])

export default __exports__